import { render, staticRenderFns } from "./PostImageDropzone.vue?vue&type=template&id=5341b3d0"
import script from "./PostImageDropzone.vue?vue&type=script&lang=ts"
export * from "./PostImageDropzone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports